import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { apiRoute, stateEnum } from "../constants/enum";
import { toast } from "react-toastify"
import customAPI from "../api/customAPI.js"
const { production } = stateEnum

const initialState = {
    isNewEntry: true,
    detailParams: []
}
export const setProductionEntryDetail = createAsyncThunk("getproductionentry detail",
    async ({ comp_code, token, db_user ,chal_no,rp_id}) => {
        try {

            const { data } = await customAPI.post(
                apiRoute.production.fetchEntryDetail,
                {
                    compcode: comp_code,
                    db_user: db_user,
                    chalno:chal_no,
                    rpid:rp_id

                },
                {
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                }
            )
            return data.data
        }
        catch (error) {
            toast.error("Data not found", {
                position: "top-center"
            })
            console.log(error)
        }
    })

const productionSlice = createSlice({
    name: production,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;

        },
        resetDetailParams: (state) => {
            state.detailParams = []
            state.isNewEntry = true

        },
        setDetailParams: (state,action) => {
            state.detailParams = action.payload
        },
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(setProductionEntryDetail.fulfilled, (state, action) => {
    //             state.detail = action.payload
    //         })
    //         .addCase(setProductionEntryDetail.rejected, (state, action) => {
    //             state.detail = []
    //         })
    // }
})

export const{setNewEntryMode,resetDetailParams,setDetailParams}=productionSlice.actions
export default productionSlice.reducer